module.exports = __webpack_public_path__ + "static/media/work-pocket-change.f59c889f.jpg";